import StoreConfig from '@/config';
import clsx from 'clsx';
import parse from 'html-react-parser';
import { useState } from 'react';

const CategoryDescription = props => {
  const { description, filterLabelGroup } = props;
  const [showDescription, setShowDescription] = useState(true);
  const descriptionTextClass = clsx(
    'not-italic font-normal text-[15px] leading-5 py-[15px] origin-top transition-all [transition-duration:300ms]',
    '[&_a]_underline',
    '[&_p]_mb-4',
    !showDescription && 'scale-y-0',
  );

  let content = description;

  if (content && content.indexOf('<div data-content-type="html" data-appearance="default" data-element="main">') > -1) {
    content = content.replace(
      /<div data-content-type="html" data-appearance="default" data-element="main">|<\/div>|&gt;|&lt;|&amp;/g,
      function (match) {
        return {
          '<div data-content-type="html" data-appearance="default" data-element="main">': '',
          '</div>': '',
          '&gt;': '>',
          '&lt;': '<',
          '&amp;': '&',
        }[match];
      },
    );
  }

  // 处理链接
  const availableCountries = StoreConfig.available_countries;

  const currentCountryCode = StoreConfig.current_country_code;

  const currentCountry = availableCountries.find(temp => temp.code === currentCountryCode);

  if (content) {
    content = content.replaceAll('awbridal.com', currentCountry?.url);
  }

  if (content) {
    // 添加处理函数来移除所有链接末尾的斜杠
    const removeTrailingSlashes = html => {
      return html.replace(/href="([^"]+)\/"/g, 'href="$1"');
    };

    // 先处理 HTML 内容，再进行解析
    const processedDescription = removeTrailingSlashes(content);
    const parsed = parse(processedDescription.replace(/##filter##/g, filterLabelGroup.toLowerCase()));

    // 后面的代码保持不变...
    if (Array.isArray(parsed)) {
      // 兼容编辑器保存后的不同格式
      if (parsed?.length === 3) {
        content = (
          <div className='mt-[38px]  hidden pt-[30px]  lg_block'>
            <div
              className='flex cursor-pointer items-center justify-center gap-x-2.5 text-lg font-medium leading-[22px]'
              onClick={() => {
                setShowDescription(x => !x);
              }}
            >
              {parsed?.[0]?.props?.children}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='6'
                fill='none'
                viewBox='0 0 12 6'
                className={!showDescription ? 'rotate-180' : ''}
              >
                <path
                  fill='#80583F'
                  d='M1.207 0h9.586a.5.5 0 0 1 .353.854L6.354 5.646a.5.5 0 0 1-.708 0L.854.854A.5.5 0 0 1 1.207 0'
                />
                <path
                  fill='#000'
                  fillOpacity='0.2'
                  d='M1.207 0h9.586a.5.5 0 0 1 .353.854L6.354 5.646a.5.5 0 0 1-.708 0L.854.854A.5.5 0 0 1 1.207 0'
                />
              </svg>
            </div>
            <div className={descriptionTextClass}>{parsed?.[2]?.props?.children}</div>
          </div>
        );
      } else {
        content = (
          <div className='mt-[38px] hidden pt-[30px]  lg_block'>
            <div
              className='flex cursor-pointer items-center justify-center gap-x-2.5 text-lg font-medium leading-[22px]'
              onClick={() => {
                setShowDescription(x => !x);
              }}
            >
              {parsed?.[0]?.props?.children}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='6'
                fill='none'
                viewBox='0 0 12 6'
                className={!showDescription ? 'rotate-180' : ''}
              >
                <path
                  fill='#80583F'
                  d='M1.207 0h9.586a.5.5 0 0 1 .353.854L6.354 5.646a.5.5 0 0 1-.708 0L.854.854A.5.5 0 0 1 1.207 0'
                />
                <path
                  fill='#000'
                  fillOpacity='0.2'
                  d='M1.207 0h9.586a.5.5 0 0 1 .353.854L6.354 5.646a.5.5 0 0 1-.708 0L.854.854A.5.5 0 0 1 1.207 0'
                />
              </svg>
            </div>
            <div className={descriptionTextClass}>
              {parsed.map((temp, index) => {
                if (index === 0 || temp === '\n') {
                  return null;
                }

                return <p key={index}>{temp?.props?.children}</p>;
              })}
            </div>
          </div>
        );
      }
    } else {
      content = (
        <div className='mt-[38px]  hidden pt-[30px] lg_block'>
          <div
            className='flex cursor-pointer items-center justify-center gap-x-2.5 text-lg font-medium leading-[22px]'
            onClick={() => {
              setShowDescription(x => !x);
            }}
          >
            {/* {parsed.props?.children} */}
          </div>
          <div className={descriptionTextClass}>{parsed?.props?.children}</div>
        </div>
      );
    }
  }

  return content;
};

export default CategoryDescription;
